const statusColorMap = {
  draft: 'gray.500',
  new: 'blue.500',
  pending: 'orange.400',
  rejected: 'red.500',
  confirmed: 'green.500',
  delivery_provider_rejected: 'red.600',
  currier_pickup: 'purple.500',
  in_warehouse: 'yellow.600',
  shipping_to_pickup: 'cyan.500',
  in_pickup_address: 'teal.500',
  shipping_to_delivery: 'blue.400',
  in_delivery_address: 'green.600',
  completed: 'green.700',
  canceled: 'red.400',
  return: 'orange.500',
  in_progress: 'blue.600',
};

/**
 * @param {string} status - One of the values from OrderItemStatusEnum.
 * @returns {string} Color string (e.g., "red.500").
 */
export function getOrderStatusColor(status) {
  return statusColorMap[status?.toLowerCase()] || 'gray.400';
}
